import { props } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Grid } from '../../packages/kiti/components/structure/Grid'
import { useColors } from '../../packages/kiti/components/theme/_hooks/colors'
import Tag from '../../packages/kiti/components/presentation/Tag'

const UsagesTags = ({ value }) => {
  const { t } = useTranslation()
  const colors = useColors()

  const TAG_COLORS = {
    form: colors.blue,
    serviceOrder: colors.darkGreen,
    actionPlan: colors.darkOrange
  }

  return (
    <Grid justify="flex-start" gutter={0.2} wrap flex={1} {...props}>
      {value?.map(item => (
        <Tag key={item} color={TAG_COLORS[item]} label={t('entity.' + item)} size="small" transparent />
      ))}
    </Grid>
  )
}

export default UsagesTags
